/**
 * Estructura inicial de una cotización nueva.
 * Centralizada para que tanto el wizard como el backend usen la misma forma.
 */
export const createEmptyQuote = (user) => ({
  cliente: {
    nombre: '',
    puesto: '',
    empresa: '',
    rfc: '',
    email: '',
    telefono: '',
    ciudad: '',
    estado: '',
    segmento: 'desarrollador',
    comoNosConocio: '',
  },
  proyecto: {
    nombre: '',
    tipo: 'residencial-horizontal',
    estatus: 'preventa',
    ubicacion: '',
    unidades: '',
    superficie: '',
    descripcion: '',
    tieneRenders: false,
    tieneFotos: false,
    tieneModelo3D: false,
    tieneIdentidad: false,
  },
  productos: [],
  descuentos: {
    bundle: false,
    bundlePct: 10,
    codigos: [],
    elementosPrevios: false,
    elementosPreviosPct: 5,
  },
  pago: {
    esquema: '12-iguales',
    notas: '',
    licenciaPrepagada: false,
    licenciaPrepagadaPrecio: 20000,
  },
  submarcaManual: false,
  submarca: 'group',
  subtotal: 0,
  descuentoTotal: 0,
  descuentoPct: 0,
  total: 0,
  ajusteManual: 0,
  fechaCreacion: new Date().toISOString(),
  creadoPor: user?.nombre || '',
  creadoPorUsername: user?.username || '',
  estatus: 'borrador',
});
